import type { BetaProfileIntegrationProvider } from '@/types/beta-dashboard'

export const betaSocialNetworkOptions = [
    { id: 1, name: 'Instagram' },
    { id: 2, name: 'Foursquare' },
    { id: 3, name: 'Behance' },
    { id: 4, name: 'Facebook' },
    { id: 5, name: 'YouTube' },
    { id: 6, name: 'Twitter' },
    { id: 10, name: 'WhatsApp' },
    { id: 11, name: 'Vimeo' },
    { id: 12, name: 'TikTok' },
    { id: 13, name: 'LinkedIn' },
    { id: 14, name: 'Pinterest' },
] as const

export const betaSocialNetworkName = (api: number) => (
    betaSocialNetworkOptions.find((option) => option.id === Number(api))?.name || 'Rede social'
)

export const normalizeBetaIntegrationUsername = (
    provider: BetaProfileIntegrationProvider,
    value: string,
) => {
    let username = String(value || '').trim()

    if (provider === 'insta') {
        return username
            .replace('@', '')
            .replace(' ', '')
            .replace('/?hl=pt-br', '')
            .replace('https://www.instagram.com/', '')
            .replace('/', '')
            .trim()
    }

    username = username
        .replace('/featured/', '')
        .replace('/featured', '')

    const parts = username.split('/')
    username = parts[parts.length - 1] || parts[parts.length - 2] || ''

    return username.replace(/ /g, '').replace('?view_as=subscriber', '')
}
